/*
 * Monthly verification allowances, read by `services/quota.ts` when it works out
 * how much of a period a user has left.
 *
 * This file used to also carry plan prices and two placeholder Stripe price ids
 * (`price_1QjXXXXX`, `price_1QjYYYYY`). Nothing ever read either — checkout has
 * always resolved the real id from `plans.stripe_price_id` in the database — but
 * they sat here looking authoritative, in a file called plans.ts, waiting for
 * someone to wire them up to a live charge. Removed.
 *
 * Prices now live in one place per surface: `scripts/pricing/planPrices.mjs`
 * defines them, Stripe and the `plan_prices` table are written from it, and the
 * UI reads them through `usePricing()`. Do not reintroduce an amount here.
 *
 * The limits below must stay in step with `TIER_META` in
 * `components/pricing/plans.ts`, which is what the pricing page shows.
 */
export const PLANS = {
    FREE: {
        id: 'free',
        name: 'Free',
        limits: {
            verifications: 15
        }
    },
    COLLECTOR: {
        id: 'collector',
        name: 'Collector',
        limits: {
            verifications: 200
        }
    },
    DEALER: {
        id: 'dealer',
        name: 'Dealer',
        limits: {
            verifications: 1500
        }
    }
};

export const CHECK_CREDIT_COST = 1; // 1 credit per check regardless of method
